import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import { useStyles } from './ErrorText.styles'

type ErrorTextProps = {
  children?: React.ReactNode
  noMarginTop?: boolean
}

export const ErrorText = ({ children, noMarginTop }: ErrorTextProps) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <p className={cx(classes.error, !noMarginTop && classes.marginTop)}>
      {children ||
        t('An error occurred. Please try again later or contact the support.')}
    </p>
  )
}
